import React, { useCallback, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import HeaderMotiva from '../../assets/home-plataforma-logo-motiva-beneficios.png';
import Button from '../Button';

import { Container, LogoContainer, ButtonDiv } from './styles';

const Header: React.FC = () => {
  const { pathname } = useLocation();
  const { push } = useHistory();
  const [menuToggle, setMenuToggle] = useState(false);

  return (
    <>
      <Container>
        <LogoContainer>
          <img src={HeaderMotiva} alt="HeaderMotiva" />
        </LogoContainer>
        <span>
          Entrega e recarga rápida, extrato de uso dos cartões, PIX, carteira
          digital, e prazos imbatíveis você só encontra na credenciada exclusiva
          Motiva.
        </span>
        <a
          href="http://motivabeneficios.com.br/transfacil-diferenciais/?utm_source=site-transfacil&utm_medium=topo&utm_id=lead-transfacil-difer"
          target="blank"
        >
          <ButtonDiv>
            <Button color="orange" padding="2">
              CLIQUE E SAIBA MAIS
            </Button>
          </ButtonDiv>
        </a>
      </Container>
    </>
  );
};

export default Header;
